// @flow
import AuthActions from 'auth/AuthActions';
import CurrentUser from 'auth/CurrentUser';
import setupCriteria from 'setup/utils/setupCriteria';
import type { RouterState } from 'lib/ReactRouterTypes';

function getUser() {
  const user = CurrentUser.isSignedIn() && CurrentUser.getUser();
  if (user) {
    return Promise.resolve(user);
  }
  return AuthActions.checkLoggedInAndLoadAppData();
}

function requireSetup(nextState: RouterState, replaceWith: Function, callback: Function) {
  getUser()
    .then(user => {
      if (!user) {
        callback();
        return;
      }
      const step = setupCriteria.getNextEligibleStep(user);
      // If we found an eligible setup step transition to it.
      // Otherwise do nothing and stay in the current route.
      if (step) {
        replaceWith({ pathname: step, state: nextState });
      }
      callback();
    })
    .catch(() => {
      console.log('Failed to get user in RequireSetup');
      callback();
    });
}

export default requireSetup;
